import Masthead from "./components/Masthead";
import HeroHot from "./components/HeroHot";
import HotRanking from "./components/HotRanking";
import FeedGrid from "./components/FeedGrid";
import FeatureEditorial from "./components/FeatureEditorial";
import TopicZone from "./components/TopicZone";
import FaqBlock from "./components/FaqBlock";
import BrandAbout from "./components/BrandAbout";
import SiteFooter from "./components/SiteFooter";
import BackToTop from "./components/BackToTop";
import { FAQS } from "@/mocks/contents";

const webpageLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "吃瓜嘿料｜实锤证据、石锤图文、实锤汇总一网打尽",
  url: "https://caacool.cn/",
  inLanguage: "zh-CN",
  isPartOf: { "@type": "WebSite", name: "吃瓜嘿料", url: "https://caacool.cn/" },
  description:
    "吃瓜嘿料聚合实锤证据与石锤图文，还原事件脉络、厘清时间线，为读者提供可追溯、有边界的娱乐圈吃瓜资讯。",
};

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  return (
    <>
      <Masthead />
      <main id="main-content">
        <HeroHot />
        <HotRanking />
        <FeedGrid />
        <FeatureEditorial />
        <TopicZone />
        <FaqBlock />
        <BrandAbout />
      </main>
      <SiteFooter />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
    </>
  );
}